<div>
  <wl-invoice-summary *ngIf="!isNewMemberInvoice" [invoice]="invoice" [isEditable]="false"></wl-invoice-summary>
  <div *ngFor="let lineItem of invoice.LineItems; index as i" [hidden]="lineItem.DeleteLineItem">
    <wl-invoice-line-item
      [invoice]="invoice"
      [invoiceLineItem]="lineItem"
      [allUsers]="allUsers"
      [allRevenueItems]="allRevenueItems"
      (removeClicked)="removeLineItem(i)"
    ></wl-invoice-line-item>
    <hr />
  </div>

  <button pButton type="button" class="btn btn-secondary" type="button" (click)="addLineItem()">
    {{ 'invoices.invoice-builder.line-items-tab.add-line-item' | translate | uppercase }}
  </button>
</div>
<p-confirmDialog
  
  icon="pi pi-exclamation-triangle"
  appendTo="body"
>
  <ng-template pTemplate="header">
    {{ 'invoices.invoice-builder.line-items-tab.adjustments-payments-warning' | translate | titlecase }}
  </ng-template>
</p-confirmDialog>
